var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBoxApr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 67,
    viewBox: "0 0 214 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_410_462)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213.667,
    height: 67,
    fill: "#28272C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.03
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11103 38.623H-1.88965C-2.9557 38.623 -3.92573 39.2391 -4.37894 40.204L-21.3802 76.4004C-22.2369 78.2243 -20.906 80.3198 -18.8909 80.3198H-7.70753C-6.63735 80.3198 -5.66435 79.699 -5.2134 78.7285L11.6052 42.5321C12.4522 40.7092 11.1212 38.623 9.11103 38.623Z",
    fill: "#B5EBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0271 38.623H42.9198C44.9277 38.623 46.2587 40.7049 45.4162 42.5274L38.2719 57.9806C37.822 58.9537 36.8477 59.5767 35.7756 59.5767H20.5815L28.6293 76.3818C29.5035 78.2073 28.1729 80.3198 26.1488 80.3198H15.1687C14.1024 80.3198 13.1322 79.7034 12.6791 78.7382L5.52476 63.4954C4.66872 61.6716 5.99963 59.5767 8.01438 59.5767H20.5815L29.5308 40.2192C29.9806 39.246 30.955 38.623 32.0271 38.623Z",
    fill: "#B5EBFF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_410_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213.667,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBoxApr);
export default __webpack_public_path__ + "static/media/BgBoxApr.4b5f222453f6426d546921300ce7d63e.svg";
export { ForwardRef as ReactComponent };